import React, { useEffect } from 'react'
import selectIcon from "../../../../assets/icons/select-all.svg";
import deleteIcon from "../../../../assets/icons/Delete-transparent.svg";
import "./DashBoard.css";

interface TopnavBarProps {
    handlecheck: () => void;
    hanldeConfirmDelete: () => void;
    listToRender: any;
    isActive: any;
    setIsActive: (value: boolean) => void;

}
const TopnavBar: React.FC<TopnavBarProps> = ({ handlecheck, hanldeConfirmDelete, listToRender, isActive, setIsActive }) => {


    return (
        <div className='d-flex gap-2 justify-content-end align-items-center '>
            <div className="select-all-button-list">
                <button type='button' className={`select-all-buttons ${isActive ? "active" : ""}`}
                    onClick={() => {
                        handlecheck();
                        setIsActive(!isActive);
                    }}
                    disabled={listToRender?.length === 0}

                >
                    <img src={selectIcon} alt="select" width={18}/>
                    <span>{isActive ? "DeSelect" : "Select"}</span>
                </button>
            </div>
            <div className="delete-button-wrappers">
                <button type='button' className={`select-all-buttons ${isActive ? 'active' : ''}`}
                    onClick={hanldeConfirmDelete}
                    disabled={listToRender?.length === 0}
                >
                    <img src={deleteIcon} width={18} alt="delete" />
                    Delete
                </button>
            </div>
        </div>
    )
}

export default TopnavBar;
